import React from "react";
import { Flame, Wind, Droplets, Thermometer, Wrench, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    icon: Flame,
    title: "Furnaces & Forced Air Heating",
    desc: "High-efficiency furnace installation, repair, and seasonal maintenance to keep your home warm through BC's chilliest winters.",
    image: "/img/services/furnaces.webp",
    testId: "service-furnace",
  },
  {
    icon: Wrench,
    title: "Natural Gas Fitting & Installations",
    desc: "Licensed gas fitters delivering safe, code-compliant installations for residential and commercial properties across the Lower Mainland.",
    image: "/img/services/gas-fitting.webp",
    testId: "service-gas",
  },
  {
    icon: Droplets,
    title: "Hot Water Tanks & Tankless Heaters",
    desc: "Traditional hot water tanks and modern tankless systems, energy-efficient solutions matched to your household needs.",
    image: "/img/services/tankless-heater.webp",
    testId: "service-water",
  },
  {
    icon: Wind,
    title: "Air Conditioning Services",
    desc: "Central AC and ductless mini-split installation, repair, and maintenance. Access CleanBC rebates for energy upgrades.",
    image: "/img/services/ac-maintenance.webp",
    testId: "service-ac",
  },
  {
    icon: Thermometer,
    title: "Heat Pump Installation",
    desc: "Cold-climate heat pumps that heat and cool with one efficient system, qualifying for CleanBC rebates.",
    image: "/img/services/heat-pump.jpg",
    testId: "service-heatpump",
  },
];

const Services = () => {
  return (
    <section id="services" className="relative py-20 lg:py-28 cg-pink-bg overflow-hidden" data-testid="services-section">
      <div className="absolute inset-0 cg-halftone-light opacity-50 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow justify-center inline-flex mb-4">How We Help</div>
          <h2 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4">
            Complete HVAC &amp; Mechanical Services
          </h2>
          <p className="text-[#475569] text-lg">
            Everything you need to keep your home or business comfortable, efficient, and safe, all under one roof.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                className="service-card group"
                data-testid={s.testId}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F]/60 to-transparent" />
                  <div className="absolute top-4 left-4 w-12 h-12 rounded-full bg-[#E50914] flex items-center justify-center shadow-lg">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-[Manrope] font-bold text-[#0F0F0F] text-xl mb-2">
                    {s.title}
                  </h3>
                  <p className="text-[#475569] text-sm leading-relaxed mb-4">
                    {s.desc}
                  </p>
                  <a
                    href="#contact"
                    className="inline-flex items-center gap-1.5 text-[#E50914] font-semibold text-sm hover:gap-3 transition-all"
                    data-testid={`${s.testId}-link`}
                  >
                    Learn more
                    <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
